import {
  createPreferenceProc,
  deletePreferenceProc,
  flushPreferenceForTesting,
  getPreferenceProc,
  updatePreferenceProc,
} from '@/appLogic/leanpath/wrappers';
import { CacheManage, clearDriversTable, getTable, initCacheDataWithDummyDriver, prepareTable } from '@/appLogic/common/cacheManage';

const tableName = 'preferenceTbl';
let preferenceTable: CacheManage;
/**
 *
 */
const getPreferenceTableSync = () => preferenceTable;
/**
 *
 */
const getPreferenceTable = async () => {
  if (!preferenceTable) preferenceTable = await getTable(tableName);
  return preferenceTable;
};

/**
 *
 */
const clearPreferenceTable = async () => {
  await getPreferenceTableSync().flush();
  await clearDriversTable(tableName);
};
/**
 *
 */
const clearPreferenceDataInServer = async () => {
  await clearPreferenceTable();
  await getPreferenceTableSync().flushForTesting();
};

/**
 *
 * @param connectServer
 */
const preparePreferenceTable = async (connectServer = true) => {
  if (connectServer) {
    preferenceTable = await prepareTable(tableName, 'ownerName', 'kind', undefined, {
      createAdapter: createPreferenceProc,
      updateAdapter: updatePreferenceProc,
      readAdapter2: getPreferenceProc,
      deleteAdapter: deletePreferenceProc,
      flushForTestingAdapter: flushPreferenceForTesting,
    });
  } else {
    await initCacheDataWithDummyDriver(tableName, 'ownerName', 'kind');
    preferenceTable = await getTable(tableName);
  }
};

export { getPreferenceTable, getPreferenceTableSync, preparePreferenceTable, clearPreferenceTable, clearPreferenceDataInServer };
